import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={25 * (props.hx ?? 1)}
    viewBox="0 0 17 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2043_96"
      maskUnits="userSpaceOnUse"
      x="0.87793"
      y="0.044342"
      width="16"
      height="24"
      fill="black"
    >
      <rect fill="white" x="0.87793" y="0.044342" width="16" height="24" />
      <path d="M8.87816 22.471C7.67928 22.471 4.56155 23.9846 2.76076 22.0933C1.31769 20.5775 1.85069 16.9326 2.88512 14.4799C3.26988 13.5672 3.29415 12.6989 3.27793 11.7141C3.20224 7.0345 1.61684 1.04651 2.75354 1.04434C3.89024 1.04217 5.37839 12.8043 8.87816 12.9243C12.3779 13.0443 11.8779 8.52434 12.3779 6.32434C12.8779 4.12434 13.5617 1.04434 14.2535 1.04434C14.9454 1.04434 14.8707 4.12435 14.8707 5.00434C14.8707 5.88433 14.5209 9.62051 14.5698 11.7141C14.5928 12.6989 14.486 13.5677 14.8707 14.4799C15.9052 16.933 16.4382 20.578 14.9951 22.0933C13.1943 23.9846 10.077 22.471 8.87816 22.471Z" />
    </mask>
    <path
      d="M8.87816 22.471C7.67928 22.471 4.56155 23.9846 2.76076 22.0933C1.31769 20.5775 1.85069 16.9326 2.88512 14.4799C3.26988 13.5672 3.29415 12.6989 3.27793 11.7141C3.20224 7.0345 1.61684 1.04651 2.75354 1.04434C3.89024 1.04217 5.37839 12.8043 8.87816 12.9243C12.3779 13.0443 11.8779 8.52434 12.3779 6.32434C12.8779 4.12434 13.5617 1.04434 14.2535 1.04434C14.9454 1.04434 14.8707 4.12435 14.8707 5.00434C14.8707 5.88433 14.5209 9.62051 14.5698 11.7141C14.5928 12.6989 14.486 13.5677 14.8707 14.4799C15.9052 16.933 16.4382 20.578 14.9951 22.0933C13.1943 23.9846 10.077 22.471 8.87816 22.471Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M8.87816 22.471C7.67928 22.471 4.56155 23.9846 2.76076 22.0933C1.31769 20.5775 1.85069 16.9326 2.88512 14.4799C3.26988 13.5672 3.29415 12.6989 3.27793 11.7141C3.20224 7.0345 1.61684 1.04651 2.75354 1.04434C3.89024 1.04217 5.37839 12.8043 8.87816 12.9243C12.3779 13.0443 11.8779 8.52434 12.3779 6.32434C12.8779 4.12434 13.5617 1.04434 14.2535 1.04434C14.9454 1.04434 14.8707 4.12435 14.8707 5.00434C14.8707 5.88433 14.5209 9.62051 14.5698 11.7141C14.5928 12.6989 14.486 13.5677 14.8707 14.4799C15.9052 16.933 16.4382 20.578 14.9951 22.0933C13.1943 23.9846 10.077 22.471 8.87816 22.471Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2043_96)"
    />
  </svg>
);
export default SvgNormal;
